import { Route } from 'vue-router';
import store from '@/store';

export default async (to, from, next) => {
  const token = store.getters['user/idToken'] || localStorage.getItem('id_token');
  if (token) {
    return next();
  }

  await store.dispatch('user/logout');
  next({ name: 'login' });
};
